import { ArrowLeft } from "lucide-react";

export const ViewHeader = ({ title, subtitle, onBack, action }) => (
  <div className="mb-6">
    {onBack && (
      <button
        data-testid="admin-back-to-dashboard"
        onClick={onBack}
        className="inline-flex items-center gap-1.5 text-sm text-purple-700 hover:text-fuchsia-600 mb-3"
      >
        <ArrowLeft className="w-4 h-4" /> Back to dashboard
      </button>
    )}
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="font-display text-2xl font-bold text-purple-950">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  </div>
);

export const EmptyState = ({ children }) => (
  <div className="bg-white rounded-2xl border border-purple-100 p-12 text-center text-muted-foreground">{children}</div>
);

export const StatusPill = ({ tone = "gray", children, testId }) => {
  const tones = {
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    gray: "bg-gray-50 text-gray-600 border-gray-200",
  };
  return (
    <span data-testid={testId} className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium border ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-ZA") : "—");
